<template>
    <div class="modal fade show" style="display: block; background: rgba(0,0,0,0.5);" @click.self="close">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Additional Site</h5>
                    <button type="button" class="close" @click="close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submit">
                        <div class="form-group">
                            <label for="domain">Domain</label>
                            <multiselect v-model="form.domain" tag-placeholder="" @search-change="domainFind"
                                :searchable="true" :loading="loadingTypeahead" placeholder="Search for a domain"
                                label="domain" track-by="domain" :options="domain || []" :multiple="false">
                            </multiselect>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" :disabled="loading">
                                <span v-if="loading">Adding...</span>
                                <span v-else>Add Site</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['websiteId'],
    data() {
        return {
            form: {
                domain: null
            },
            domain: [],
            loading: false,
            loadingTypeahead: false,
            usedDomainIds: [],
            dbtm: null
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        async submit() {
            if (!this.form.domain) {
                this.$notify.addError('Please select a domain')
                return
            }

            this.loading = true

            try {
                await this.$api.postReq(`website/${this.websiteId}/add-site`, {
                    domain_id: this.form.domain._id
                })

                this.$notify.addSuccess('Additional site added successfully')
                this.$emit('reload')
                this.close()
            } catch (error) {
                this.$notify.addError('Failed to add additional site')
            } finally {
                this.loading = false
            }
        },
        async loadUsedDomains() {
            try {
                const website = await this.$api.getReq(`website/${this.websiteId}`)
                this.usedDomainIds = [
                    website.body.data.domain._id,
                    ...website.body.data.additional_sites.map(site => site.domain._id)
                ]
            } catch (error) {
                this.$notify.addError('Failed to load website data')
            }
        },
        domainFind(query) {
            if (query === '') {
                return
            }
            this.domain = []

            this.loadingTypeahead = true
            clearTimeout(this.dbtm)
            this.dbtm = setTimeout(() => {
                this.$api.getReq('typeahead/domain?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    res.body.data.domain.map(d => {
                        if (!this.usedDomainIds.includes(d._id)) {
                            this.domain.push({
                                _id: d._id,
                                domain: d.domain
                            })
                        }
                    })
                })
            }, 500)
        }
    },
    mounted() {
        this.loadUsedDomains()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/AddSite.vue